import {  } from '@/api/api';

export default {
  namespaced: true,
  state: {
    SEO:{
      title: 'Live soccer data and algorithmic predictions | LuckScore',
      keywords: 'livescores, soccer, data, prediction, football, luckscore',
      description: 'LuckScore provides live match data and algorithmic predictions for football fans.'
    },
  },
  mutations: {
    setSEO: (state, data) => {
      state.SEO = data;
    },
  },
  actions: {
   
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/home.js